import { Injectable } from "@angular/core";
import { AbstractControl, FormGroup, ValidatorFn } from "@angular/forms";
import {COUNTRY_INPUT_CONTROL, INTERNATIONAL_COUNTRY_CONTROL} from "../../shared/constants";

@Injectable({
  providedIn: "root"
})
export class BSACountryListValidator {
  public checkCountryListIfNecessary(): ValidatorFn {
    return (control: AbstractControl) => {
      const error: any = {};
      const formGroup = control as FormGroup;
      const { wireInternational, internationalCountry } = formGroup.value;
      const selectedCountryList = !Array.isArray(internationalCountry)
        ? (!!internationalCountry ? [internationalCountry] : [])
        : internationalCountry;
      if (wireInternational) {
        if (!selectedCountryList.length) {
          error[INTERNATIONAL_COUNTRY_CONTROL] = true;
          error[COUNTRY_INPUT_CONTROL] = true;
          formGroup.controls[INTERNATIONAL_COUNTRY_CONTROL].setErrors({ "required": true , emitEvent: false });
          formGroup.controls[COUNTRY_INPUT_CONTROL].setErrors({ "required": true , emitEvent: false });
          return error;
        }
      }
      else{
        formGroup.controls[INTERNATIONAL_COUNTRY_CONTROL].setErrors(null);
        formGroup.controls[COUNTRY_INPUT_CONTROL].setErrors(null);
      }

      return null;
    }
  }
}
